const windowFlag = '__proveDisableNumberInputWheel__'

type WindowWithFlag = Window & { [windowFlag]?: boolean }

export const disableNumberInputWheel = () => {
  if (typeof document === 'undefined' || globalThis.window === undefined) {
    return
  }

  const typedWindow = globalThis as unknown as WindowWithFlag
  if (typedWindow[windowFlag]) {
    return
  }

  typedWindow[windowFlag] = true
  document.addEventListener(
    'wheel',
    (event) => {
      const target = event.target
      if (target instanceof HTMLInputElement && target.type === 'number') {
        event.preventDefault()
      }
    },
    { passive: false, capture: true }
  )
}
